import Cookies from 'universal-cookie';
import localforage from 'localforage';

let cookies = new Cookies();

export function userLogout(){
    if(cookies.get('token')){
        cookies.remove('token')
        cookies.remove('user_id')
        cookies.remove('groupNum')
        localforage.clear().then(function() {
            // Run this code once the database has been entirely deleted.
            console.log('Database is now empty.')
        }).catch(function(err) {
            // This code runs if there were any errors
            console.log(err)
        })
        location.reload()
    }
}



// WEBPACK FOOTER //
// ./src/utility/logout.js